import { memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';

import { useDeps } from '@Contexts/DI';
import Link from '@UI/Link';
import styles from './OnlineConsultation.module.css';

import type { FC, HTMLAttributes } from 'react';

export type SupportLink = {
  name: string;
  link?: string;
  img: string;
  cb?: () => Promise<void>;
};

export interface OnlineConsultationProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  links: SupportLink[];
  closeHandler?: () => void;
}

const OnlineConsultation: FC<OnlineConsultationProps> = (props) => {
  const { className, links, closeHandler, ...restProps } = props;
  const { analytics } = useDeps();

  const handleClick = useCallback(
    (link, cb) => {
      analytics.dispatchEvent('link.external.click', { link });
      if (cb) cb();
      if (closeHandler) closeHandler();
    },
    [analytics, closeHandler],
  );

  if (!links) return null;

  return (
    <div {...restProps} className={cn(styles.onlineConsultation, className)}>
      {links.map((item, index) => (
        <Link
          className={styles.contact}
          to={item.link}
          target='_blank'
          key={index}
          onClick={() => handleClick(item.link, item?.cb)}
        >
          <img src={item.img} alt={item.name} className={styles.image} />
        </Link>
      ))}
    </div>
  );
};

export default memo(OnlineConsultation);
